import React, { useEffect, useState } from "react";
import RegularImage from "../../../images/slides/slide-b.jpg";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  PreviewCard,
  BlockBetween,
  Button,
  Icon,
} from "../../../components/Component";
import { Label, Input, Row, Col } from "reactstrap";
import { useForm, FormProvider } from "react-hook-form";
import FormInput from "../../form-components/InputComponent";
import FormSelect from "../../form-components/SelectComponent";
import FormDatePicker from "../../form-components/DatePicker";
import FormCheckbox from "../../form-components/CheckboxComponent";
import { useFormContext } from "react-hook-form";
import { getCountrys, getStatesByCountry } from "../../../api/misc/dropDowns";
import usersApis from "../../../api/master/users";
// import misc from "../../../api/misc/miscService";
// Define the structure of your form data
interface SelectOptions {
  label: string;
  value: string;
}
const ContactInformation: React.FC = (props: any) => {
  const methods = useForm({
    mode: "onChange",
  });
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    trigger,
    reset,
  }: any = useFormContext<FormData>();
  // Watch relevant fields
  const [sameAsCompany, setSameAsCompany]: any = useState(true);

  useEffect(() => {}, []);

  const submitForm = (data: FormData) => {
    props.next();
  };

  const [countries, setCountries] = useState<SelectOptions[]>([]);
  const [states, setStates] = useState<SelectOptions[]>([]);
  const [districtOptions, setDistrictOptions] = useState<SelectOptions[]>([]);

  // Example city fetching based on country
  const [cities, setCities] = useState([]);

  const getCountries = async () => {
    try {
      const _countries = await usersApis.getCountrys();
      if (_countries.status) {
        if (_countries.data.length > 0) {
          const transformedData = _countries.data.map((item: any) => ({
            value: item.countryId.toString(),
            label: item.countryName,
          }));
          setCountries(transformedData);
        }
      }
    } catch (error: any) {
      console.log(error.message);
    }
  };
  const fetchStatesByCountry = async (countryId: string, stateId?: string) => {
    try {
      const data = await usersApis.getStatesByCountry(countryId);
      const stateOptions = data?.data?.map((state: any) => ({
        value: state.stateId.toString(),
        label: state.stateName,
      }));
      if (stateOptions.length > 0) setStates(stateOptions);
      if (stateId) {
        const state = stateOptions.find(
          (state: SelectOptions) => state.value === stateId
        );
        if (!state) {
          return;
        }
        setValue("state", state.value);
      }
    } catch (error) {}
  };
  const getDistricts = async (stateID: any) => {
    try {
      const districts = await usersApis.getDistrictsByState(stateID);
      console.log(districts);
      if (districts.status) {
        if (districts.data.length > 0) {
          const transformedData = districts.data.map((item: any) => ({
            value: item.districtId.toString(),
            label: item.districtName,
          }));
          setDistrictOptions(transformedData);
        }
      }
    } catch (error: any) {
      console.log(error.message);
    }
  };

  const onStateChange = (e: any) => {
    getDistricts(e);
  };

  useEffect(() => {
    getCountries();
  }, []);

  // Simulating fetching cities by country
  function fetchCitiesByCountry(country: string) {
    if (country === "usa") {
      return [
        { value: "nyc", label: "New York" },
        { value: "la", label: "Los Angeles" },
      ];
    } else if (country === "canada") {
      return [
        { value: "toronto", label: "Toronto" },
        { value: "vancouver", label: "Vancouver" },
      ];
    }
    return [];
  }
  return (
    <>
      <form className="content clearfix" onSubmit={handleSubmit(submitForm)}>
        <Row className="gy-4">
          <Col lg="4">
            <FormInput
              name="contactPerson"
              label="Contact Person"
              required={true}
              // disabled={action === "view"}
              type="text"
              placeholder="Enter Contact Person"
            />
          </Col>
          <Col lg="4">
            <FormInput
              name="phoneNumber"
              label="Phone Number"
              required={true}
              type="text"
              pattern={/^\d+$/} // Allows only digits
              onInput={(e: any) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Removes non-numeric characters
              }}
              placeholder="Enter Phone Number"
            />
          </Col>
          <Col lg="4">
            <FormInput
              name="email"
              label="Email"
              required={true}
              // disabled={action === "view"}
              type="email"
              maxLength={50}
              placeholder="Enter Email address"
              pattern={/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/}
            />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col lg="4">
            <FormSelect
              name="country"
              label="Country"
              options={countries}
              required={true}
              placeholder="-Select-"
              onChange={(e) => {
                fetchStatesByCountry(e);
              }}
            />
          </Col>
          <Col lg="4">
            <FormSelect
              name="state"
              label="State"
              required={true}
              options={states}
              placeholder="Select State"
              onChange={(ev) => onStateChange(ev)}
            />
          </Col>
          <Col lg="4">
            <FormSelect
              name="district"
              label="District"
              options={districtOptions}
              required={true}
              placeholder="Select District"
            />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col lg="4">
            <FormInput
              name="city"
              label="City"
              // required={true}
              // disabled={action === "view"}
              placeholder="Enter City"
              type="text"
            />
          </Col>
          <Col lg="4">
            <FormInput
              name="area"
              // disabled={action === "view"}
              label="Area"
              // required={true}
              placeholder="Enter Area"
            />
          </Col>
          <Col lg="4">
            <FormInput
              name="pincode"
              // disabled={action === "view"}
              label="Zip/Pincode"
              required={true}
              type="text"
              pattern={/^\d+$/} // Allows only digits
              onInput={(e: any) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Removes non-numeric characters
              }}
              placeholder="Enter Zip or pin code"
            />
          </Col>
        </Row>

        <div className="actions clearfix">
          <ul>
            <li>
              <Button color="primary" type="submit">
                Next
              </Button>
            </li>
            <li>
              <Button
                color="primary"
                onClick={props.prev}
                className="btn-dim btn btn-secondary"
              >
                Previous
              </Button>
            </li>
          </ul>
        </div>
      </form>
    </>
  );
};
export default ContactInformation;
